import axios from "axios";
import DataView from "./components/DataView";
import { SellPumpToken } from "../../Transactions";
import { useState } from "react";
import { toast } from 'sonner';
import { Input } from "../../../components/ui/input";
import { Button } from "../../../components/ui/button";


import UserInputs from "./components/UserInputs";

import { useDispatch, useSelector } from "react-redux";
import { setToken } from "../../lib/SessionSlice";

import { FaPowerOff } from "react-icons/fa";
import { ImPowerCord } from "react-icons/im";

import Disclaimer from "./components/Disclaimer";
// import Checker from "./Checker";




let pumpSocket = null

export default function Phoenix() {


  let address = "B4wH4yhC99Q5zhxrNXbTz1t9tUQ6JeZNagHh9YqPHsZx"

  const SOCKET_ENDPOINT = process.env.REACT_APP_PUMPSOCKET_ENDPOINT
  const dispatch = useDispatch()

  const session = useSelector(state => state.session)

  const { bot } = session



  const checkFileds = () => {

    if (bot?.amount == "" || bot?.maxOpenTrades == "" || bot?.secret == "" || bot?.marketCap == "" || bot?.sellMc == "" || bot?.ownerTokenHoldings == '' || bot?.stopLoss == "") {
      return false
    } else {
      return true
    }
  }

  const [connected, setConnected] = useState(false)
  const [tradingActive, setTradingActive] = useState(false)

  const [profitableTokens, setProfitableTokens] = useState(null)
  const [liveTradesData, setLiveTradesData] = useState(null)
  //check marketcap and bonding curve
  const filterByMarketCap = async (tkn) => {
    const tMc = Number(tkn?.marketCapSol)
    const bcs = Number(tkn?.vSolInBondingCurve)
    const r = bcs - tMc
    if (tMc >= Number(bot?.marketCap) && r <= 2) {
      setProfitableTokens(tkn)
      return tkn
    }
  }

  const startBot = async () => {
    // Open WebSocket connection if it's not already open
    let checked = checkFileds()
    let walletRegex = `^[1-9A-HJ-NP-Za-km-z]{32,44}$`
    let secretKeyRegex = `^[1-9A-HJ-NP-Za-km-z]{88}$`

    // let validArrdess = walletRegex.test(bot.address)
    // let validKey = secretKeyRegex.test(bot.secret)
    //   if (!validKey) {
    //     toast.error('secret key is invalid')
    //   }
    //   if (!validArrdess) {
    //     toast.error('wallet address invalid')
    //   }

    if (false || !checked ) {
      toast.error('please double Check the fields')
      return
    } 
    else {
      if (!pumpSocket || pumpSocket?.readyState === WebSocket.CLOSED) {
        pumpSocket = new WebSocket(SOCKET_ENDPOINT);
        pumpSocket.onopen = () => {
          const payload = {
            method: "subscribeNewToken",
          };
  
          pumpSocket.send(JSON.stringify(payload));
          setConnected(true);
          setTradingActive(true)
          toast.success('Auto trading started ...')
          toast("connected to Pump Servers !")
        };
  
        pumpSocket.onmessage = (event) => {
          const message = JSON.parse(event.data);
          if (message?.txType == "create") {
            filterByMarketCap(message)
  
          }
  
          if (message?.txType == "buy" || message?.txType == "sell") {
            setLiveTradesData(message)
          }
        };
        pumpSocket.onerror = (err) => {
          console.error('WebSocket error:', err);
          setTradingActive(false)
          setConnected(false);
          pumpSocket = null
        };
        pumpSocket.onclose = () => {
          setTradingActive(false)
          setConnected(false);
          pumpSocket = null
        };
      } else {
        console.log('WebSocket is already open.');
      }
    }



  };

  const endBot = () => {
    // Ensure the socket is open before attempting to unsubscribe and close it
    if (connected) {

      const payload = {
        method: "unsubscribeNewToken",
      };
      pumpSocket.send(JSON.stringify(payload));
      console.log('WebSocket connection closed');


      pumpSocket.close();

      // Close the WebSocket connection
      setConnected(false)
      pumpSocket = null
    } else {
      console.log('WebSocket is not open or already closed.');
    }
  };



  const checkAddress = () => {

        if (pumpSocket?.readyState === WebSocket.CLOSED || pumpSocket == null ) {
          startBot()
         
        } else if (pumpSocket?.readyState === WebSocket.OPEN) {
          setTradingActive(true)
          toast.success('Auto trading continued ...')
        }

      
  }


  const startTrading = () => {
    checkAddress()
  }

  const pauseTrading = () => {
    setTradingActive(false)
    toast.warning('Auto trading desactivated ...')
  }


  return (
    <div className="container mx-auto space-y-5 py-5 min-h-screen h-max relative">
      <div className="flex justify-between flex-wrap  items-center border shadow-xs p-5 rounded bg-gradient-to-tl from-neutral-900 to-transparent border-yellow-500/10 ">
        <div className="flex flex-col gap-2 text-neutral-200 relative">
          <h1 className='font-bold text-lg md:text-xl lg:text-2xl font-jaro text-yellow-500'>Pheonix</h1>
        </div>
        <div className=" flex gap-5 items-center">

          <h1 className='font-bold text-xs  text-yellow-500'>PUMP BETA</h1>
          <Disclaimer   />
        </div>

        <div className="grid  gap-2">
          <div className="flex gap-5 items-center justify-end">
            {!connected ?
              <>
                <span className="w-max gap-1 bg-red-500 rounded-full p-1 items-center jusitfy-center flex hover:cursor-pointer hover:bg-red-500 transition-all hover:scale-110"  >
                  <ImPowerCord className="text-white text-xl animate-pulse " />
                </span>
                <span className=" text-xs text-red-500 font-bold">Server Disconnected</span>
              </>
              :
              <>
                <span className="w-max gap-1 bg-green-500 rounded-full p-1 items-center jusitfy-center flex hover:cursor-pointer hover:bg-red-500 transition-all hover:scale-110" >
                  <FaPowerOff className="text-white text-xl " />
                </span>
                <span className="font-bold text-sm text-green-500 ">connected</span>
              </>}
          </div>
        </div>
      </div>

<div className="flex w-full ">

      <UserInputs tradingActive={tradingActive} connected={connected}  >

        <div className={` w-full space-y-2 md:w-80 `}>
          {!tradingActive ? <Button disabled={!checkFileds()} onClick={startTrading} className="rounded w-full bg-blue-500 text-white py-2 px-5 hover:bg-orange-900 disabled:bg-neutral-400" >start Demo</Button> : <Button onClick={pauseTrading} className="rounded w-full bg-red-500 text-white py-2 px-5 hover:bg-neutral-800" >Stop trading</Button>}

          <div className={`flex flex-col gap-2 bg-black p-2 rounded w-full `}>
            <p className="text-white text-xs  ">in case a token could not be solde you can input the mint address and sell manually </p>
            <Input className=" focus-visible:ring-purple-500 text-xs  placeholder:text-xs" name='rpc' placeholder='Sell Blocked tokens "enter mint address"' onChange={(e) => dispatch(setToken({ mint: e.target.value }))} />
            {<Button className="w-full" variant="destructive" onClick={() => SellPumpToken(bot, session?.token?.mint)}>sell</Button>}
          </div>
          {/* <Button className="rounded w-full bg-red-400 hover:bg-red-500 text-white py-2 px-5" onClick={() => subscribeTrades()}>Subscribe</Button> */}

      
        </div>
      </UserInputs >


        </div>


      <DataView
        tradingActive={tradingActive}
        connected={connected}
        liveTradesData={liveTradesData}
        profitableTokens={profitableTokens}
        pumpSocket={pumpSocket}
        setTradingActive={setTradingActive}
        />

    </div>
  );
}
